exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Label-module__regularLabel___g6IRL{padding:3px 10px 1px;border-radius:200px;font-size:10px;color:#fff;width:fit-content;opacity:.8;margin-right:8px;font-weight:400;height:fit-content}.Label-module__regularLabel___g6IRL.Label-module__logica___20ulI,.Label-module__regularLabel___g6IRL.Label-module__rekenen___NWxyB,.Label-module__regularLabel___g6IRL.Label-module__tijd___3JJOl{background-color:#2daae1}.Label-module__regularLabel___g6IRL.Label-module__data___24VdJ,.Label-module__regularLabel___g6IRL.Label-module__structuur___JujVu{background-color:#fece15}.Label-module__regularLabel___g6IRL.Label-module__interactief___3WvU2,.Label-module__regularLabel___g6IRL.Label-module__interface___b3eSn{background-color:#e8308b}.Label-module__regularLabel___g6IRL.Label-module__creatief___2jzFN,.Label-module__regularLabel___g6IRL.Label-module__knutselen___3Jmk-,.Label-module__regularLabel___g6IRL.Label-module__muziek___VPkPj,.Label-module__regularLabel___g6IRL.Label-module__tekenen___EKR4D{background-color:#504c9a}", ""]);

// exports
exports.locals = {
	"regularLabel": "Label-module__regularLabel___g6IRL",
	"rekenen": "Label-module__rekenen___NWxyB",
	"logica": "Label-module__logica___20ulI",
	"tijd": "Label-module__tijd___3JJOl",
	"structuur": "Label-module__structuur___JujVu",
	"data": "Label-module__data___24VdJ",
	"interactief": "Label-module__interactief___3WvU2",
	"interface": "Label-module__interface___b3eSn",
	"creatief": "Label-module__creatief___2jzFN",
	"muziek": "Label-module__muziek___VPkPj",
	"tekenen": "Label-module__tekenen___EKR4D",
	"knutselen": "Label-module__knutselen___3Jmk-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/Label/Label.module.scss
// module id = 6t8m
// module chunks = 0